var uiAssetClassBadge = {
	bond: "Bono",
	commodity: "Materia prima",
	currency: "Moneda",
	debt: "Deuda",
	etf: "ETF",
	fund: "Fondo",
	generic: "Genérico",
	index: "Índice",
	stock: "Acción",
	interestRate: "Tasa de Interés",
	structuredProduct: "Producto Estructurado",
	investmentProduct: "Producto de Inversión",
	leveragedProduct: "Producto Apalancado",
	future: "Futuro",
	option: "Opción"
};
var es = {
	uiAssetClassBadge: uiAssetClassBadge
};

export { es as default, uiAssetClassBadge };
